import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "item-container mt-1 mb-1" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!

  return (_openBlock(), _createBlock(_component_v_autocomplete, {
    modelValue: _ctx.selected,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selected) = $event)),
    "search-input": _ctx.query,
    "onUpdate:searchInput": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.query) = $event)),
    variant: "solo",
    density: "compact",
    "no-filter": "",
    "hide-no-data": "",
    "auto-select-first": "",
    clearable: "",
    class: "ml-4",
    "data-testid": "map-search-bar",
    "menu-icon": null,
    error: _ctx.placeNotFound,
    "error-messages": _ctx.placeNotFound ? _ctx.t('map.location_not_found') : '',
    placeholder: _ctx.t('search'),
    loading: _ctx.loading,
    items: _ctx.items,
    "item-title": "text",
    "item-value": "value",
    "allow-overflow": false,
    "menu-props": {
      maxWidth: '300px',
      offsetY: true,
      rounded: true,
    },
    "onClick:clear": _ctx.handleClearInput,
    "onUpdate:search": _ctx.handleSearchInput
  }, {
    "prepend-inner": _withCtx(() => [
      _createVNode(_component_v_icon, null, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode("mdi-magnify", -1)
        ]))]),
        _: 1
      })
    ]),
    item: _withCtx(({ props, item }) => [
      _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", null, [
              (item.value.icon)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: item.value.icon,
                    alt: "location icon"
                  }, null, 8, _hoisted_2))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("span", null, _toDisplayString(item.value.postcode), 1),
            _createElementVNode("span", null, _toDisplayString(item.value.name), 1),
            _createElementVNode("span", null, _toDisplayString(item.value.state), 1)
          ])
        ]),
        _: 2
      }, 1040)
    ]),
    _: 1
  }, 8, ["modelValue", "search-input", "error", "error-messages", "placeholder", "loading", "items", "onClick:clear", "onUpdate:search"]))
}